import { render, staticRenderFns } from "./playerView.vue?vue&type=template&id=1e375478&scoped=true&"
import script from "./playerView.vue?vue&type=script&lang=js&"
export * from "./playerView.vue?vue&type=script&lang=js&"
import style0 from "./playerView.vue?vue&type=style&index=0&id=1e375478&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e375478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e375478')) {
      api.createRecord('1e375478', component.options)
    } else {
      api.reload('1e375478', component.options)
    }
    module.hot.accept("./playerView.vue?vue&type=template&id=1e375478&scoped=true&", function () {
      api.rerender('1e375478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/playerView.vue"
export default component.exports